import {
  LuBug,
  LuClipboardList,
  LuCode,
  LuFileText,
  LuCircleHelp,
  LuMessageSquare,
  LuPalette,
  LuRocket,
  LuSearch,
  LuShield,
  LuTarget,
  LuTrendingUp,
  LuUsers,
} from "react-icons/lu";

export const AEOHeroData = {
  backgroundImage: "/images/serviceBanners/AEO_Banner.webp",
  whiteImage: "/images/serviceBanners/AEO_Banner_white.webp",
  subTitle: "Answer Engine Optimization Services",
  title: (
    <>
      Win More Visibility with{" "}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">
        Answer Engine Optimization (AEO) Services
      </span>
    </>
  ),
  description:
    "We build structured AEO strategies that help your content appear in direct answers, featured responses, voice search, and AI-powered search experiences to improve discoverability, strengthen relevance, and drive qualified traffic for your business.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Answer Engine Visibility",
      desc: "Comprehensive audits focused on content clarity, answer relevance, structured data, and discoverability across answer-driven platforms.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Direct Answer Optimization",
      desc: "Create concise, accurate, and structured responses designed for direct answer and featured snippet opportunities.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Content Relevance",
      desc: "Intent-focused research and content plans that provide useful answers to real user questions.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Sustainable Discoverability",
      desc: "Optimize answer-led content to attract qualified users, improve engagement, and generate higher-value enquiries.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const aeoAboutData = [
  {
    title: "Improve Visibility Across Answer-Driven Search",
    content: (
      <>
        Answer Engine Optimization helps businesses structure digital information so search engines, AI assistants, and answer-focused platforms can understand and present accurate
        responses to relevant user questions. Effective Answer Engine Optimization Services focus on clear explanations, contextual relevance, structured information, and useful
        answers rather than simple keyword placement. Tycho Technologies provides AEO Services that help brands make their expertise easier to discover across evolving search
        experiences. This approach supports users searching for services, comparisons, recommendations, and decision-focused information while helping businesses build stronger
        visibility and qualified engagement.
      </>
    ),
  },
  {
    title: "Create Content Around Real User Questions",
    content: (
      <>
        As an experienced Answer Engine Optimization Company, we focus on understanding how customers phrase questions and what information they expect before making a decision.
        Businesses working with an Answer Engine Optimization Agency need content that answers informational, commercial, and transactional queries clearly. We create
        question-focused service content, comparisons, definitions, supporting explanations, and decision-stage information that improves content usefulness. By addressing genuine
        customer concerns and providing concise answers with sufficient context, businesses can strengthen their relevance across answer engines while creating a better experience
        for website visitors.
      </>
    ),
  },
  {
    title: "Reach High-Intent Audiences Across India",
    content: (
      <>
        Our Answer Engine Optimization Services in India help businesses reach customers who increasingly use conversational and question-based searches to find products and
        services. As an Answer Engine Optimization Company in India, Tycho Technologies studies search behaviour, audience concerns, service-related questions, and buying intent to
        develop relevant content. We also connect AEO initiatives with{" "}
        <a href="https://tychotechnologies.com/digital-marketing-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          Digital Marketing Services India
        </a>{" "}
        strategies to maintain consistent messaging across digital channels. Accurate business details, well-developed topic coverage, and useful decision-making information can
        help brands establish greater credibility while attracting audiences actively researching solutions.
      </>
    ),
  },
  {
    title: "Strengthen Local and Commercial Discoverability",
    content: (
      <>
        Our Answer Engine Optimization Services in Delhi NCR are designed for businesses targeting customers with local and commercial search intent. Working with an Answer Engine
        Optimization Company in Delhi helps organizations address location-specific questions, service availability, customer expectations, and buying considerations. We also align
        answer-focused strategies with{" "}
        <a href="https://tychotechnologies.com/seo-content-strategy-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          SEO Company India
        </a>{" "}
        practices to support visibility across traditional search and emerging answer-based experiences. Through stronger information accessibility, commercial relevance, and
        user-focused content, businesses can increase qualified enquiries, strengthen digital credibility, and create more opportunities for customers to discover their services.
      </>
    ),
  },
];

export const aeoDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Answer-Focused AEO Strategies for Better Search Visibility",
  buildCards: [
    {
      title: "Answer Engine Audits",
      desc: "Comprehensive audits focused on content clarity, answer relevance, structured data, and discoverability across answer-driven search platforms.",
      icon: LuSearch,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Query Intent Research",
      desc: "Intent-focused research to identify conversational questions, direct answer opportunities, and high-value search queries.",
      icon: LuTarget,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Answer Content Strategy",
      desc: "AEO-focused content plans designed to provide concise, accurate, and useful answers to user questions.",
      icon: LuFileText,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Structured Data Optimization",
      desc: "Implement and optimize relevant schema markup to help search engines understand content context and answer relationships.",
      icon: LuCode,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FAQ and Q&A Framework",
      desc: "Build structured question-based content around user intent, service queries, comparison topics, and decision-stage searches.",
      icon: LuCircleHelp,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Conversion-Focused AEO",
      desc: "Optimize answer-led content to attract qualified users, improve engagement, and generate higher-value business enquiries.",
      icon: LuTrendingUp,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Strategic AEO Growth Roadmap",
  processTitle: "How We Build Stronger Answer Engine Visibility",
  processSteps: [
    {
      step: "01",
      title: "Answer Visibility Audit",
      description: "Identify gaps that limit visibility across answer engines and AI-powered search experiences.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Query Mapping",
      description: "Target conversational, question-based, and intent-driven queries relevant to your audience.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Answer Optimization",
      description: "Create concise, accurate, and structured responses designed for direct answer opportunities.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Schema Enhancement",
      description: "Implement relevant structured data to improve content understanding and contextual relevance.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Content Refinement",
      description: "Improve headings, FAQs, summaries, and supporting content for stronger answer relevance.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Performance Tracking",
      description: "Monitor answer visibility, engagement, traffic, and conversions to support continuous AEO growth.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY BUSINESSES CHOOSE OUR AEO STRATEGY",
  benefitsTitle: "Building Stronger Answer Engine Visibility",
  benefits: [
    "Conversational query targeting",
    "Direct answer content optimization",
    "FAQ and Q&A structuring",
    "Schema markup enhancement",
    "Intent-focused conversion optimization",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const aeoServices = [
  {
    icon: <LuSearch size={36} />,
    title: "Answer Engine Visibility",
    description: "Improve presence in direct answers, featured responses, and AI-powered search experiences.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/answer-engine-optimization-services-india",
  },
  {
    icon: <LuMessageSquare size={36} />,
    title: "Conversational Query Targeting",
    description: "Target question-based and intent-driven searches that users ask AI assistants and answer engines.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/answer-engine-optimization-services-india",
  },
  {
    icon: <LuCircleHelp size={36} />,
    title: "FAQ & Structured Content",
    description: "Build clear Q&A frameworks and schema-enhanced content that answer engines can easily surface.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/answer-engine-optimization-services-india",
  },
];

export const aeoFaqData = [
  {
    q: "What is Answer Engine Optimization (AEO)?",
    a: "Answer Engine Optimization (AEO) is the process of optimizing website content so search engines, AI assistants, and answer platforms can understand and present accurate responses to user queries.",
  },
  {
    q: "How do Answer Engine Optimization (AEO) Services help businesses?",
    a: "Answer Engine Optimization (AEO) Services improve content clarity, question relevance, structured information, and answer visibility, helping businesses reach users searching for specific solutions and services.",
  },
  {
    q: "What is the difference between AEO Services and traditional SEO?",
    a: "AEO Services focus on direct answers, conversational queries, FAQs, and structured content, while traditional SEO mainly focuses on rankings, keywords, backlinks, and organic search traffic.",
  },
  {
    q: "Why choose an Answer Engine Optimization (AEO) Company in India?",
    a: "An Answer Engine Optimization (AEO) Company in India can create strategies based on local search behaviour, customer intent, service queries, and competitive market requirements to improve relevant digital visibility.",
  },
  {
    q: "Why choose Tycho Technologies for Answer Engine Optimization (AEO) Services in India?",
    a: "Tycho Technologies provides Answer Engine Optimization (AEO) Services in India focused on user questions, content relevance, structured information, commercial intent, and stronger visibility across answer-driven search experiences.",
  },
];

export const aeoPortfolioData = {
  subtitle: "OUR WORK",
  title: "AEO Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Answer Visibility Suite",
      badge: "AEO Platform",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "Platform for tracking and optimizing brand presence in featured answers and AI response engines.",
      downloads: "45K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "Question Intent Mapper",
      badge: "Research Tool",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Tool that identifies high-value conversational queries and maps them to answer-ready content.",
      downloads: "90K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "Schema Answer Builder",
      badge: "Structured Data",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "System for generating and validating FAQ, HowTo, and Q&A schema to boost answer eligibility.",
      downloads: "70K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
